<template>
  <div class="valid-table">
    <h3 class="table-title">
      {{
        `可导入数据${data?.passList?.length || data?.passList?.length || 0}条，${
          data?.failList?.length && data.failList.length > 0
            ? "部分数据校验失败，请检查清单内容，尝试重新导入"
            : ""
        }（校验失败：${data?.failList?.length || 0}条）`
      }}
    </h3>
    <vxe-table
      border
      :data="data?.failList"
      :height="tableHeight"
      :cell-class-name="cellClassName"
      show-overflow="tooltip"
    >
      <vxe-column fixed="left" type="seq" width="80" align="center" title="序号"></vxe-column>
      <template v-for="item in column">
        <vxe-column
          :field="item.dataIndex || item.key"
          :title="item.title"
          :min-width="item.width"
          :fixed="item.fixed"
          align="center"
          show-overflow="tooltip"
        ></vxe-column>
      </template>
      <template #empty>
        <a-empty :image="simpleImage">
          <template #description>暂无数据</template>
        </a-empty>
      </template>
    </vxe-table>
    <a-row type="flex" align="center" style="margin: 20px 0 0">
      <a-col>
        <a-button @click="updateStep(1)">上一步</a-button>
        <a-button
          type="primary"
          :disabled="!data?.passList?.length"
          @click="updateStep(3)"
          :loading="loading"
          >导入</a-button
        >
        <a-button
          @click="exportExcel()"
          v-if="data?.failList?.length && checkType && checkType != ''"
          :loading="loading || exportLoading"
          >下载校验数据</a-button
        >
      </a-col>
    </a-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { FormMultipleImportService } from "@/components/form-multiple-import/form-multiple-import.service";
export default defineComponent({
  name: "DataValid",
});
</script>

<script lang="ts" setup>
import { computed, PropType, createVNode } from "vue";
import { VxeTablePropTypes } from "vxe-table";
import { Empty, message, Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
const props = defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  fail: {
    type: Number,
    default: 0,
  },
  total: {
    type: Number,
    default: 0,
  },
  tableHeight: {
    type: Number,
    default: 200,
  },
  columns: {
    type: Array,
    default: () => [],
  },
  uploadApiFn: {
    type: Function,
    required: true,
  },
  checkType: {
    type: String,
  },
  checkKey: {
    type: String,
  },
  isExtraUploadApiFn: {
    type: Boolean,
    default: false,
  },
  extraUploadApiFn: {
    type: Function,
  },
});

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

const emit = defineEmits(["setSteps"]);

const column = computed(() => {
  return [
    ...props.columns,
    { title: "校验结论", width: 200, dataIndex: "failDesc", key: "failDesc", fixed: "right" },
  ];
});

const cellClassName: VxeTablePropTypes.CellClassName = ({ row, column }) => {
  if (column.field === "failDesc") {
    return "color-red";
  }
  return "";
};

const { run, loading } = props.uploadApiFn();
const { run: runExport, loading: exportLoading } = FormMultipleImportService.useExportExcelData();

const exportExcel = async () => {
  let res = await runExport(props.checkKey, props.checkType);
  if (res.respCode !== "0000") {
    message.error(res.respDesc);
    return;
  }
  message.success(res.respDesc);
  if (res.data && res.data.url) {
    window.open(res.data.url);
  }
};

async function updateStep(step: number) {
  if (step === 3) {
    if (props.isExtraUploadApiFn) {
      Modal.confirm({
        title: "警告",
        icon: createVNode(ExclamationCircleOutlined),
        content: "库存导入会清空原有数据并替换为导入的新数据,请谨慎操作！",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: async () => {
          const data = await run(props.data?.passList);
          if (data?.respCode === "0000") {
            emit("setSteps", step);
          }
        },
        onCancel() {},
      });
    } else {
      const data = await run(props.data?.passList);
      if (data?.respCode === "0000") {
        emit("setSteps", step);
      }
    }
  } else {
    emit("setSteps", step);
  }
}
</script>

<style lang="less" scoped>
.valid-table {
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
  height: calc(100% - 72px);
  overflow-y: auto;
  .table-title {
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
  }
  .vxe-table {
    min-height: 200px;
    margin-bottom: 10px;
    :deep(.color-red) {
      color: red;
    }
  }
}
</style>
